import { todayKey } from '~/data/weighins'

/** The day a step away from the one given, in the same `YYYY-MM-DD`. */
export function shifted(day: string, by: number): string {
  const [year = 0, month = 1, date = 1] = day.split('-').map(Number)
  return todayKey(new Date(year, month - 1, date + by))
}
